import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.find-index.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
var tagSpacing = 4;
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "handleScroll",
    value: function handleScroll(e) {
      var eventDelta = e.wheelDelta || -e.deltaY * 40;
      var scrollContainer = this.$refs.scrollContainer;
      var scrollWrapper = scrollContainer.$refs.wrap;
      scrollWrapper.scrollLeft = scrollWrapper.scrollLeft + eventDelta / 4;
    }
  }, {
    key: "moveToTarget",
    value: function moveToTarget(currentTag) {
      var scrollContainer = this.$refs.scrollContainer;
      var container = scrollContainer.$el;
      var containerWidth = container.offsetWidth;
      var scrollWrapper = scrollContainer.$refs.wrap;
      var tagList = this.$parent.$refs.tag;
      var firstTag = null;
      var lastTag = null;
      // find first tag and last tag
      if (tagList.length > 0) {
        firstTag = tagList[0];
        lastTag = tagList[tagList.length - 1];
      }
      if (firstTag === currentTag) {
        scrollWrapper.scrollLeft = 0;
      } else if (lastTag === currentTag) {
        scrollWrapper.scrollLeft = scrollWrapper.scrollWidth - containerWidth;
      } else {
        // find preTag and nextTag
        var currentIndex = tagList.findIndex(function (item) {
          return item === currentTag;
        });
        var prevTag = tagList[currentIndex - 1];
        var nextTag = tagList[currentIndex + 1];
        // the tag's offsetLeft after of nextTag
        var afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagSpacing;
        // the tag's offsetLeft before of prevTag
        var beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagSpacing;
        if (afterNextTagOffsetLeft > scrollWrapper.scrollLeft + containerWidth) {
          scrollWrapper.scrollLeft = afterNextTagOffsetLeft - containerWidth;
        } else if (beforePrevTagOffsetLeft < scrollWrapper.scrollLeft) {
          scrollWrapper.scrollLeft = beforePrevTagOffsetLeft;
        }
      }
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'ScrollPane'
})], default_1);
export default default_1;